import { IPlanParent } from "./types";

export const PARENT_PLAN_STARTER_TYPE = "starter";
export const PARENT_PLAN_PRO_TYPE = "pro";
export const PARENT_PLAN_ENTERPRISE_TYPE = "enterprise";
export const PARENT_PLAN_EMBEDDING = "embedding";
export const PARENT_PLAN_INTERNAL = "internal";
export const PARENT_PLAN_LEGACY = "legacy";
export const PARENT_PLAN_TYPES = [
  PARENT_PLAN_STARTER_TYPE,
  PARENT_PLAN_PRO_TYPE,
  PARENT_PLAN_ENTERPRISE_TYPE,
  PARENT_PLAN_EMBEDDING,
  PARENT_PLAN_INTERNAL,
  PARENT_PLAN_LEGACY,
] as const;

export const PARENT_PLANS: IPlanParent[] = [
  {
    type: PARENT_PLAN_STARTER_TYPE,
    title: "Starter",
    description: "Perfect for small teams or individuals",
    plans: [],
  },
  {
    type: PARENT_PLAN_PRO_TYPE,
    title: "Pro",
    description: "For larger teams & advanced use cases",
    plans: [],
  },
] as const;

// hosting
const HOSTING_FEATURE_INVOICE_ELIGIBILITY = "invoicing-eligibility";
const HOSTING_FEATURE_INVOICEABLE = "invoiceable";
const HOSTING_FEATURE_TRIAL_UP = "trial-up";
const HOSTING_FEATURE_CLICKHOUSE_DWH = "clickhouse-dwh";
const HOSTING_FEATURE_CUSTOM_DOMAIN = "custom-domain";
const HOSTING_FEATURE_DEDICATED_NODE = "dedicated-node";
const HOSTING_FEATURE_METABASE_API_KEY = "metabase-api-key";
const HOSTING_FEATURE_METABASE_AI = "metabase-ai";
const HOSTING_FEATURE_SEMANTIC_SEARCH_DB = "semantic-search-db";

export const HOSTING_FEATURES = [
  HOSTING_FEATURE_INVOICE_ELIGIBILITY,
  HOSTING_FEATURE_INVOICEABLE,
  HOSTING_FEATURE_TRIAL_UP,
  HOSTING_FEATURE_CLICKHOUSE_DWH,
  HOSTING_FEATURE_CUSTOM_DOMAIN,
  HOSTING_FEATURE_DEDICATED_NODE,
  HOSTING_FEATURE_METABASE_API_KEY,
  HOSTING_FEATURE_METABASE_AI,
  HOSTING_FEATURE_SEMANTIC_SEARCH_DB,
  "etl-connections",
  "python-runner",
  "transforms",
  "transforms-basic",
  "transforms-advanced",
  "advanced-transforms",
  "product-analytics",
  "dummy",
] as const;

// token
const TOKEN_FEATURE_ATTACHED_DWH = "attached-dwh";
const TOKEN_FEATURE_HOSTING = "hosting";
const TOKEN_FEATURE_SSO = "sso";
const TOKEN_FEATURE_SSO_JWT = "sso-jwt";
const TOKEN_FEATURE_SSO_SAML = "sso-saml";
const TOKEN_FEATURE_SSO_LDAP = "sso-ldap";
const TOKEN_FEATURE_SSO_GOOGLE = "sso-google";
const TOKEN_FEATURE_DISABLE_PASSWORD_LOGIN = "disable-password-login";
const TOKEN_FEATURE_SESSION_TIMEOUT_CONFIG = "session-timeout-config";
const TOKEN_FEATURE_EMBEDDING = "embedding";
const TOKEN_FEATURE_AUDIT_APP = "audit-app";
const TOKEN_FEATURE_SANDBOXES = "sandboxes";
const TOKEN_FEATURE_WHITELABEL = "whitelabel";
const TOKEN_FEATURE_ADVANCED_CONFIG = "advanced-config";
const TOKEN_FEATURE_ADVANCED_PERMISSIONS = "advanced-permissions";
const TOKEN_FEATURE_EMAIL_ALLOW_LIST = "email-allow-list";
const TOKEN_FEATURE_EMAIL_RESTRICT_RECIPIENTS = "email-restrict-recipients";
const TOKEN_FEATURE_CACHE_GRANULAR_CONTROLS = "cache-granular-controls";
const TOKEN_FEATURE_DASHBOARD_SUBSCRIPTION_FILTERS =
  "dashboard-subscription-filters";
const TOKEN_FEATURE_CONFIG_TEXT_FILE = "config-text-file";
const TOKEN_FEATURE_CONTENT_MANAGEMENT = "content-management";
const TOKEN_FEATURE_CONTENT_VERIFICATION = "content-verification";
const TOKEN_FEATURE_OFFICIAL_COLLECTIONS = "official-collections";
const TOKEN_FEATURE_SNIPPET_COLLECTIONS = "snippet-collections";
const TOKEN_FEATURE_METABASE_STORE_MANAGED = "metabase-store-managed";
const TOKEN_FEATURE_NO_UPSELL = "no-upsell";
const TOKEN_FEATURE_SERIALIZATION = "serialization";
const TOKEN_FEATURE_UPLOAD_MANAGEMENT = "upload-management";

export const TOKEN_FEATURES = [
  TOKEN_FEATURE_ATTACHED_DWH,
  TOKEN_FEATURE_HOSTING,
  TOKEN_FEATURE_SSO,
  TOKEN_FEATURE_SSO_JWT,
  TOKEN_FEATURE_SSO_SAML,
  TOKEN_FEATURE_SSO_LDAP,
  TOKEN_FEATURE_SSO_GOOGLE,
  TOKEN_FEATURE_DISABLE_PASSWORD_LOGIN,
  TOKEN_FEATURE_SESSION_TIMEOUT_CONFIG,
  TOKEN_FEATURE_EMBEDDING,
  TOKEN_FEATURE_AUDIT_APP,
  TOKEN_FEATURE_SANDBOXES,
  TOKEN_FEATURE_WHITELABEL,
  TOKEN_FEATURE_ADVANCED_CONFIG,
  TOKEN_FEATURE_ADVANCED_PERMISSIONS,
  TOKEN_FEATURE_EMAIL_ALLOW_LIST,
  TOKEN_FEATURE_EMAIL_RESTRICT_RECIPIENTS,
  TOKEN_FEATURE_CACHE_GRANULAR_CONTROLS,
  TOKEN_FEATURE_DASHBOARD_SUBSCRIPTION_FILTERS,
  TOKEN_FEATURE_CONFIG_TEXT_FILE,
  TOKEN_FEATURE_CONTENT_MANAGEMENT,
  TOKEN_FEATURE_CONTENT_VERIFICATION,
  TOKEN_FEATURE_OFFICIAL_COLLECTIONS,
  TOKEN_FEATURE_SNIPPET_COLLECTIONS,
  TOKEN_FEATURE_METABASE_STORE_MANAGED,
  TOKEN_FEATURE_NO_UPSELL,
  TOKEN_FEATURE_SERIALIZATION,
  TOKEN_FEATURE_UPLOAD_MANAGEMENT,
  "cache-preemptive",
  "scim",
  "collection-cleanup",
  "database-auth-providers",
  "embedding-sdk",
  "semantic-search",
  "etl-connections",
  "ai-sql-generation",
  "ai-sql-fixer",
  "ai-entity-analysis",
  "metabot-v3",
  "sso-slack",
  "transforms-basic",
  "transforms-python",
  "transforms",
  "product-analytics",
  "dummy",
] as const;

export const PLAN_ALIAS_INTERNAL = "internal";
export const PLAN_ALIAS_BUSINESS = "business";

export const PLAN_ALIAS_STARTER = "starter";
export const PLAN_ALIAS_STARTER_YEARLY = "starter-yearly";

export const PLAN_ALIAS_PRO_SELF_HOSTED = "pro-self-hosted";
export const PLAN_ALIAS_PRO_SELF_HOSTED_YEARLY = "pro-self-hosted-yearly";
export const PLAN_ALIAS_PRO_SELF_HOSTED_DEV = "pro-self-hosted-dev";
export const PLAN_ALIAS_PRO_SELF_HOSTED_DEV_YEARLY =
  "pro-self-hosted-dev-yearly";

export const PLAN_ALIAS_PRO_CLOUD = "pro-cloud";
export const PLAN_ALIAS_PRO_CLOUD_YEARLY = "pro-cloud-yearly";
export const PLAN_ALIAS_PRO_CLOUD_DEV = "pro-cloud-dev";
export const PLAN_ALIAS_PRO_CLOUD_DEV_YEARLY = "pro-cloud-dev-yearly";

// It should be maintained
// with the list of all plan aliases
// as the e2e tests use it
// to get a list of plans to tests against
export const PLAN_ALIASES = [
  PLAN_ALIAS_STARTER,
  PLAN_ALIAS_STARTER_YEARLY,
  PLAN_ALIAS_PRO_SELF_HOSTED,
  PLAN_ALIAS_PRO_SELF_HOSTED_YEARLY,
  PLAN_ALIAS_PRO_SELF_HOSTED_DEV,
  PLAN_ALIAS_PRO_SELF_HOSTED_DEV_YEARLY,
  PLAN_ALIAS_PRO_CLOUD,
  PLAN_ALIAS_PRO_CLOUD_YEARLY,
  PLAN_ALIAS_PRO_CLOUD_DEV,
  PLAN_ALIAS_PRO_CLOUD_DEV_YEARLY,
  PLAN_ALIAS_INTERNAL,
  PLAN_ALIAS_BUSINESS,
  "enterprise-cloud",
  "enterprise-self-hosted",
  "embedding_premium",
  "embedding_premium_yearly_1",
  // Legacy
  "original",
  "growth",
  "growth-v2.0",
  "startup",
  "starter-v2",
] as const;
